"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMapPoint = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var theme_palette_1 = require("../../components/theme.palette");
var dom_1 = require("../../dom");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var projection_cache_1 = require("../google/projection.cache");
var point_collection_cache_1 = require("./point.collection.cache");
var CSS = {
    container: 'c-MapCollection',
    title: 'c-MapCollection__title',
    titleText: 'c-MapCollection__titleText',
    point: 'c-MapCollection__point',
    line: 'c-MapCollection__line',
    isHovered: 'c-MapCollection--is-hovered',
    isSelected: 'c-MapCollection--is-selected',
    isInspected: 'c-MapCollection--is-inspected'
};
var CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 1.5;
var CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
var CIRCLE_BORDER_SIZE_THICK = 3;
var CIRCLE_BORDER_SIZE = 2;
var TITLE_WIDTH = 120;
var TITLE_PADDING = theme_1.DefaultTheme.spacingFactor;
var ZOOM_LINE_LEVEL = 18;
var SITE_TYPE_COLORS = {
    1: 'rgb(82,11,144)', // purple
    2: 'rgb(72,187,120)' // green
};
var DROP_POLE_COLORS = {
    1: 'rgb(255,0,0)', // red
    2: 'rgb(0,255,0)' // green
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        position: 'absolute'
    },
    _a[CSS.point] = {
        height: CIRCLE_SIZE_PX,
        width: CIRCLE_SIZE_PX,
        minWidth: CIRCLE_SIZE_PX,
        maxWidth: CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        border: "".concat(CIRCLE_BORDER_SIZE, "px solid ").concat((0, theme_1.rgba)(theme_palette_1.BLACK, 0.5))
    },
    _a["".concat(CSS.isHovered, ", .").concat(CSS.isSelected, ", .").concat(CSS.isInspected)] = {
        zIndex: 99
    },
    _a["".concat(CSS.point, ".").concat(CSS.isSelected)] = {
        boxShadow: "0 0 0 3px rgba(".concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.24), 0 0 0 3px rgba(").concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.64)"),
        border: "".concat(CIRCLE_BORDER_SIZE, "px solid rgba(255, 255, 255, 0.87)")
    },
    _a["".concat(CSS.point, ".").concat(CSS.isInspected)] = {
        boxShadow: "0 0 0 3px rgba(".concat(theme_palette_1.ColorPaletteBlue.C700, ", 0.24), 0 0 0 3px rgba(").concat(theme_palette_1.ColorPaletteBlue.C700, ", 0.64)"),
        border: "".concat(CIRCLE_BORDER_SIZE, "px solid rgba(255, 255, 255, 0.87)")
    },
    _a["".concat(CSS.point, ".").concat(CSS.isHovered)] = {
        cursor: 'pointer',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5
    },
    _a["".concat(CSS.point, ".").concat(CSS.isHovered, ".").concat(CSS.isSelected)] = {
        boxShadow: "0 0 0 5px rgba(".concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.24), 0 0 0 5px rgba(").concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.64)")
    },
    _a[CSS.title] = {
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        height: theme_1.DefaultTheme.space(6),
        lineHeight: theme_1.DefaultTheme.space(6),
        fontSize: '125%',
        position: 'absolute',
        width: "".concat(TITLE_WIDTH, "px"),
        textAlign: 'center',
        'pointer-events': 'none'
    },
    _a[CSS.titleText] = {
        backgroundColor: '#FFF',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        padding: "0 ".concat(TITLE_PADDING, "px"),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    _a));
var GREY_COLOR = 'rgb(160,174,192)';
exports.CollectionMapPoint = {
    view: function (state, summary, point) {
        var _a, _b;
        var _c;
        var hoverId = page_state_1.CurrentState.hoverId;
        var isHovered = hoverId === summary.revision;
        var isSelected = page_state_1.CurrentState.Tag.isCollectionSelected(summary.tags[0], summary.uuid);
        var isInspected = page_state_1.CurrentState.inspectedCollectionRevision === summary.revision;
        var isTagHovered = summary.tags.indexOf(hoverId) > -1;
        var isDetailShown = isHovered || state.showDetail;
        var stateCSS = "".concat(isInspected ? CSS.isInspected : '', " ").concat(isSelected ? CSS.isSelected : '', " ").concat((isTagHovered || isHovered) ? CSS.isHovered : '');
        var collection = (0, mithril_1.m)('div', (_a = {
                key: summary.objectId
            },
            _a[dom_1.DRAGON_ID] = summary.revision,
            _a[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.COLLECTION,
            _a.className = "".concat(CSS.point, " ").concat(stateCSS),
            _a.style = {
                // backgroundColor: ColorHash.hash(summary.tags[0]),
                top: (point.y - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px',
                left: (point.x - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px'
            },
            _a));
        // special collection coloring feature for Crown Castle
        // https://surveylab.atlassian.net/browse/IKE4-2997
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_COLORING)) {
            if (summary.siteType) {
                var siteTypeInt = parseInt(summary.siteType, 10);
                collection.attrs.style.backgroundColor = isNaN(siteTypeInt) ? GREY_COLOR : SITE_TYPE_COLORS[siteTypeInt];
            }
            else if (!(summary.dropPole === null || summary.dropPole === undefined)) {
                collection.attrs.style.backgroundColor = summary.dropPole ? DROP_POLE_COLORS[1] : DROP_POLE_COLORS[2];
            }
            else {
                collection.attrs.style.backgroundColor = GREY_COLOR;
            }
            var borderColor = core_shared_1.ColorHash.hash(summary.tags[0]);
            if (!isInspected) {
                collection.attrs.style.border = "".concat(CIRCLE_BORDER_SIZE, "px solid ").concat(borderColor);
            }
        }
        else if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG)) {
            if (summary.mapMarkerColor) {
                collection.attrs.style.backgroundColor = (_c = summary.mapMarkerColor) !== null && _c !== void 0 ? _c : GREY_COLOR;
                var borderColor = core_shared_1.ColorHash.hash(summary.tags[0]);
                if (!isInspected) {
                    collection.attrs.style.border = "".concat(CIRCLE_BORDER_SIZE_THICK, "px solid ").concat(borderColor);
                }
            }
            else {
                //if mapMarkerColor is not set, use the job color
                collection.attrs.style.backgroundColor = core_shared_1.ColorHash.hash(summary.tags[0]);
            }
        }
        else {
            collection.attrs.style.backgroundColor = core_shared_1.ColorHash.hash(summary.tags[0]);
        }
        if (isDetailShown) {
            var title = summary.title;
            if (title == null) {
                title = (0, index_1.Translate)(index_1.T.COLLECTION_MISSING_TITLE);
            }
            delete collection.attrs.key;
            collection.attrs.onclick = state.inspectHovered;
            collection = (0, mithril_1.m)('div', { key: summary.objectId }, [
                collection,
                (0, mithril_1.m)('div', (_b = {
                        key: 'hovered-' + summary.objectId
                    },
                    _b[dom_1.DRAGON_ID] = summary.revision,
                    _b[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.COLLECTION,
                    _b.className = "".concat(CSS.title, " ").concat(stateCSS),
                    _b.style = {
                        top: point.y - (theme_1.DefaultTheme.spacingFactor * 10) + 'px',
                        left: point.x - (TITLE_WIDTH / 2) + (TITLE_PADDING / 2) + 'px'
                    },
                    _b), (0, mithril_1.m)('span', { className: CSS.titleText }, title))
            ]);
        }
        if (isSelected || isInspected || isDetailShown || state.zoom > ZOOM_LINE_LEVEL) {
            if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_VECTOR)
                || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                return { collection: collection, line: exports.CollectionMapPoint.viewLines(state, summary, point) };
            }
        }
        return { collection: collection, line: null };
    },
    viewLines: function (state, summary, point) {
        var collection = store_1.AppStore.Collection.get(summary.revision);
        if (collection == null) {
            return null;
        }
        var location = point_collection_cache_1.PointCollectionCache.getCollectionLocation(summary.revision);
        if (location == null) {
            return null;
        }
        var lineInfos = point_collection_cache_1.PointCollectionCache.getCollectionVectors(summary.revision);
        var lines = [];
        var useColorCoding = services_1.Services.Token.has(core_api_1.IkeToken.PHOTOMEASURE_COLOR_CODING);
        for (var _i = 0, lineInfos_1 = lineInfos; _i < lineInfos_1.length; _i++) {
            var lineInfo = lineInfos_1[_i];
            var field = lineInfo.field, target = lineInfo.target;
            var targetPoint = projection_cache_1.PointCache.getPoint(target.latitude, target.longitude);
            var spanColor = core_shared_1.FormModelFieldSubForm.getSpanColor(field.parent);
            var color = useColorCoding && spanColor ? spanColor : core_shared_1.ColorHash.hash(field.schema.id);
            if (core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) {
                color = "rgb(".concat(theme_palette_1.ANCHOR_PINK, ")");
            }
            var line = createLine(point.x, point.y, targetPoint.x, targetPoint.y, color);
            line.attrs[dom_1.DRAGON_ID] = field.id;
            line.attrs[dom_1.DRAGON_TYPE] = 'field';
            lines.push(line);
        }
        return lines;
    }
};
var LINE_WIDTH = 1;
var LINE_HIT_BOX = LINE_WIDTH * 8;
var LineCss = {
    container: 'c-MapLine',
    hitBox: 'c-MapLine__hitbox',
    lineFill: 'c-MapLine__fill',
    info: 'c-MapLine__info'
};
function createLine(x1, y1, x2, y2, fillColor, text) {
    var topLeft = { x: Math.min(x1, x2), y: Math.min(y1, y2) };
    var bottomRight = { x: Math.max(x1, x2), y: Math.max(y1, y2) };
    var width = Math.abs(topLeft.x - bottomRight.x);
    var height = Math.abs(topLeft.y - bottomRight.y);
    var length = Math.sqrt(width * width + height * height);
    var angle = Math.atan2(y2 - y1, x2 - x1);
    var topHitBox = (y1 - LINE_HIT_BOX / 2) + 'px';
    var left = x1 + 'px';
    var lineHitBox = (0, mithril_1.m)('div', {
        className: LineCss.hitBox,
        style: {
            width: "".concat(length, "px"),
            position: 'absolute',
            display: 'flex',
            top: topHitBox,
            left: left,
            height: LINE_HIT_BOX + 'px',
            transform: "rotate(".concat(angle, "rad)"),
            'transform-origin': "0px ".concat(LINE_HIT_BOX / 2, "px")
        }
    });
    var line = (0, mithril_1.m)('div', {
        className: LineCss.lineFill,
        style: {
            width: "".concat(length, "px"),
            position: 'absolute',
            top: y1 + 'px',
            left: left,
            outline: '1px solid ' + fillColor,
            height: 0,
            transform: "rotate(".concat(angle, "rad)"),
            'transform-origin': '0px 0px'
        }
    });
    var children = [lineHitBox, line];
    return (0, mithril_1.m)('div', { className: LineCss.container }, children);
}
//# sourceMappingURL=point.collection.js.map